var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "warning-disclaimer mt-4"
  }, [_vm._v(" Please upload a clear copy of your active insurance license(s). If you are licensed, upload your license for the state in which you reside. Your registration cannot continue until your documents are uploaded. ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }